import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	prebidSectionConfig: {
		height: '100%',
		padding: '2.5rem 5rem'
	},
	size: {
		height: '100%',
		display: 'flex',
		justifyContent: 'center'
	},
	form: {
		width: '40%',
		margin: '1rem'
	},
	deviceConfig: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		backgroundColor: theme.palette.secondary.main,
		padding: '1.5rem',
		borderRadius: '5px',
		width: '100%'
	},
	code: {
		height: 'fit-content',
		margin: '1.5rem',
		display: 'flex'
	}
}));
